import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const CountryCtx = createContext(null);

export function CountryProvider({ children }) {
  const [country, setCountry] = useState(
    () => localStorage.getItem("sodimate_country") || "UAE"
  );
  const [countries, setCountries] = useState([]);

  const reload = () =>
    api.get("/reference/countries").then((r) => setCountries(r.data));

  useEffect(() => {
    reload().catch(() => {});
  }, []);

  const change = (code) => {
    localStorage.setItem("sodimate_country", code);
    setCountry(code);
  };

  const activate = async (code) => {
    const r = await api.post(`/reference/countries/${code}/activate`);
    await reload();
    change(code);
    return r.data;
  };

  return (
    <CountryCtx.Provider value={{ country, countries, change, activate, reload }}>
      {children}
    </CountryCtx.Provider>
  );
}

export const useCountry = () => useContext(CountryCtx);
